import { configureStore } from '@reduxjs/toolkit';

import allDataSlice from './CommonSlice/allDataSlice';
import authReducer from './CommonSlice/authSlice';
import toastReducer from './CommonSlice/toastSlice';
const store = configureStore({
  reducer: {
    data: allDataSlice,
    auth: authReducer,
    toast: toastReducer,
  }
});

export default store;
